import httpService from "./httpService";

export default {

  findById(id) {
    return httpService.get(`/rankingScore/${id}`);
  },

  insert(form) {
    return httpService.post("/rankingScore", form);
  },

  update(id, form) {
    return httpService.put(`/rankingScore/${id}`, form);
  },

  delete(id) {
    return httpService.delete(`/rankingScore/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/rankingScoreService.js